import type { RegistrationGate } from '@galapagos/shared';
import type { SignupTerminalStepId } from './minor-steps';

/**
 * The stop screen for the server's registration gate, or null when the member
 * may carry on. The server decides; the client never looks at an age.
 */
export function gateStopStep(
  gate: RegistrationGate,
): Extract<SignupTerminalStepId, 'under-age' | 'minor-unsupported'> | null {
  if (gate === 'under_age') return 'under-age';
  if (gate === 'minor_unsupported') return 'minor-unsupported';
  return null;
}
